export const alphabetiseFolders = (folders) => {
    const alphabetisedArray = Object.keys(folders).sort((a, b) => {
        const nameA = folders[a].DisplayName ? folders[a].DisplayName.toLowerCase() : ''
        const nameB = folders[b].DisplayName ? folders[b].DisplayName.toLowerCase() : ''
        if (nameA < nameB) {
            return -1
        }
        if (nameA > nameB) {
            return 1
        }
        return 0
    })
    return alphabetisedArray
}